import pb from '../lib/pocketbase';

// Obtener lista de usuarios con paginación
export async function getUsers(page = 1, perPage = 200) {
  return await pb.collection('users').getList(page, perPage, {
    sort: 'name',
    expand: 'role',
    $autoCancel: false,
  });
}

export async function getAllUsers() {
  return await pb.collection('users').getFullList({
    sort: 'name',
    expand: 'role',
    batch: 200,
    $autoCancel: false,
  });
}

export async function getPickerUsers() {
  const roles = await pb.collection('role').getFullList({
    filter: 'sta = true',
    $autoCancel: false,
  });

  const pickerRoleIds = roles
    .filter((role) => /mesa|picker/i.test(role.descrip || ''))
    .map((role) => role.id);

  if (!pickerRoleIds.length) {
    return [];
  }

  const roleFilter = pickerRoleIds
    .map((id) => `role = "${id.replace(/"/g, '\\"')}"`)
    .join(' || ');

  return await pb.collection('users').getFullList({
    filter: roleFilter,
    sort: 'name',
    expand: 'role',
    batch: 200,
    $autoCancel: false,
  });
}

function formatPbError(error, fallback) {
  const data = error?.response || error?.data;
  const fieldErrors = data?.data;

  if (fieldErrors && typeof fieldErrors === 'object') {
    const parts = Object.entries(fieldErrors).map(([field, detail]) => {
      if (typeof detail === 'string') return `${field}: ${detail}`;
      if (detail?.message) return `${field}: ${detail.message}`;
      return `${field}: inválido`;
    });
    if (parts.length) return parts.join(', ');
  }

  return data?.message || error?.message || fallback;
}

// Crear un nuevo usuario
export async function createUser(user) {
  try {
    return await pb.collection('users').create(user);
  } catch (error) {
    console.error('Error creating user:', error);
    throw new Error(formatPbError(error, 'Error al crear el usuario'));
  }
}

// Actualizar un usuario existente
export async function updateUser(id, user) {
  return await pb.collection('users').update(id, user);
}

// Eliminar un usuario por su ID
export async function deleteUser(id) {
  return await pb.collection('users').delete(id);
}